import { setFullRowSpan } from '@helpers/StyleHelper'

// v-grid-row: For grid layouts like FormGrid, sets the item column span to take the full row.
export default {
  inserted: setFullRowSpan,
  bind: setFullRowSpan,
}
